<template>
	<ProcessCreatePage>
		<Header :title="title">
			<p>{{ $t('drivers_license_photo_front') }} <strong>Vorderseite des Führerscheins</strong>{{ $t('drivers_license_photo_front_2') }}</p>
		</Header>

		<div class="main">
			<BaseCamera
				orientation="landscape"
				@snapshot="drivingLicenseImage = $event"
				:label="isAppContainer ? $t('activate_camera') : $t('add_photo')"
				:allow-upload-in-app-container="false"
			/>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick(false)"
			@skipButtonClick="continueButtonClick(true)"
			:is-back-button="showBackButton"
			:is-skippable="!drivingLicenseImage"
		/>
	</ProcessCreatePage>
</template>

<script>
import Header from '../Header';
import Footer from '../Footer';
import BaseCamera from '../../forms/inputs/BaseCamera';
import AppContainerMixin from '@/mixins/AppContainerMixin';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';
export default {
	name: 'DrivingLicenseImage',
	components: { ProcessCreatePage, BaseCamera, Footer, Header },
	mixins: [AppContainerMixin],
	props: {
		title: {
			default: function() {
				return this.$t('generate_form_rental_car');
			},
		},
		showBackButton: {
			default: false,
		},
	},
	data() {
		return {
			drivingLicenseImage: null,
		};
	},
	methods: {
		continueButtonClick: function(isSkip) {
			if (isSkip) {
				this.$emit('next', null);
			} else if (this.validate()) {
				this.$emit('next', this.$data);
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('upload_or_skip').toString(), 'warning');
			}
		},
		validate: function() {
			return !!this.drivingLicenseImage;
		},
	},
};
</script>

<style scoped></style>
